import { useQuery } from '@tanstack/react-query'
import { CART_QUERY_KEY } from '../CartManager'
import { useCartContext } from '../components'

export const useCart = () => {
  const { cartManager } = useCartContext()
  return useQuery({ queryKey: CART_QUERY_KEY, queryFn: cartManager.get })
}
